"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OutlineTab = exports.ScheduledCourseOverviewTabElement = exports.ScheduledCourseOverviewTab = exports.SingleSessionOverviewTab = exports.CourseOverviewTab = exports.CourseInfoBar = exports.Body = exports.CourseDetailBody = exports.Page = exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _ObjectDetailNew = babelHelpers.interopRequireWildcard(require("layouts/ObjectDetailNew"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _Overview = babelHelpers.interopRequireDefault(require("tab/Overview"));

var _TabPanel = require("components/TabPanel");

var _CourseSessionLineItem = require("components/CourseSessionLineItem");

var _base = babelHelpers.interopRequireDefault(require("block/base"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _corePlugin = babelHelpers.interopRequireDefault(require("core-plugin"));

var _noty = require("noty");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _duration = require("duration");

var _ProfileImageContainer = babelHelpers.interopRequireDefault(require("components/ProfileImageContainer"));

var _class, _descriptor, _descriptor2, _descriptor3, _temp, _class3, _descriptor4, _descriptor5, _temp2, _class5, _descriptor6, _temp3, _class7, _descriptor7, _temp4, _class9, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _temp5, _class11, _descriptor14, _descriptor15, _descriptor16, _temp6, _class13, _descriptor17, _temp7, _class15, _descriptor18, _temp8, _class17, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _temp9, _class19, _descriptor25, _descriptor26, _temp10, _class21, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _temp11, _class23, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _temp12;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var CourseDetailPage =
/*#__PURE__*/
function (_Page) {
  babelHelpers.inherits(CourseDetailPage, _Page);

  function CourseDetailPage() {
    babelHelpers.classCallCheck(this, CourseDetailPage);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(CourseDetailPage).apply(this, arguments));
  }

  babelHelpers.createClass(CourseDetailPage, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(CourseDetailBody, this.props.content);
    }
  }]);
  return CourseDetailPage;
}(_ObjectDetailNew.default);

exports.Page = exports.default = CourseDetailPage;

var CourseDetailBody =
/*#__PURE__*/
function (_Body) {
  babelHelpers.inherits(CourseDetailBody, _Body);

  function CourseDetailBody() {
    babelHelpers.classCallCheck(this, CourseDetailBody);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(CourseDetailBody).apply(this, arguments));
  }

  return CourseDetailBody;
}(_ObjectDetailNew.Body);

exports.Body = exports.CourseDetailBody = CourseDetailBody;

var InfoItem = function InfoItem(_ref) {
  var label = _ref.label,
      value = _ref.value;
  return _react.default.createElement("div", {
    className: "info-item"
  }, _react.default.createElement("div", {
    className: "info-value"
  }, value), _react.default.createElement("div", {
    className: "info-label"
  }, label));
};

var PersonItem = function PersonItem(_ref2) {
  var person = _ref2.person;
  return _react.default.createElement("div", {
    className: "info-item person-item"
  }, _react.default.createElement(_ProfileImageContainer.default, {
    className: "person-photo",
    noImageClassName: "initials",
    image: person.photo,
    name: person.name
  }), _react.default.createElement("div", {
    className: "person-info"
  }, _react.default.createElement("div", {
    className: "person-name"
  }, person.name), !!person.title && _react.default.createElement("div", {
    className: "person-title"
  }, person.title), !!person.location && _react.default.createElement("div", {
    className: "person-location"
  }, person.location)));
};

var CourseInfoBar = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(CourseInfoBar, _Component);

  function CourseInfoBar() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, CourseInfoBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(CourseInfoBar)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "person", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "difficulty", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "duration", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(CourseInfoBar, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "stack info-bar"
      }, _react.default.createElement("div", {
        className: "inner-content container"
      }, this.difficulty && _react.default.createElement(InfoItem, {
        value: this.difficulty,
        label: "Level"
      }), this.duration && _react.default.createElement(InfoItem, {
        value: this.duration,
        label: "To complete"
      }), this.person && _react.default.createElement(PersonItem, {
        person: this.person
      })));
    }
  }]);
  return CourseInfoBar;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "person", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "difficulty", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "duration", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.CourseInfoBar = CourseInfoBar;
var SessionDates = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(SessionDates, _Component2);

  function SessionDates() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, SessionDates);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(SessionDates)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "start", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "end", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(SessionDates, [{
    key: "render",
    value: function render() {
      if (!this.start || !this.end) return null;
      var ds = new Date(1000 * this.start),
          de = new Date(1000 * this.end),
          now = new Date(),
          year = '';
      if (ds.format('Y') != now.format('Y')) year = ', Y';

      if (ds.format('Ymd') == de.format('Ymd')) {
        return _react.default.createElement("p", null, ds.format("F j".concat(year)));
      }

      if (ds.format('Ym') == de.format('Ym')) {
        return _react.default.createElement("p", null, ds.format('F j'), " - ", de.format("j".concat(year)));
      }

      if (ds.format('Y') == de.format('Y')) {
        return _react.default.createElement("p", null, ds.format('F j'), " - ", de.format("F j".concat(year)));
      }

      if (1 + ds.format('Y') == de.format('Y')) {
        if (ds.format('Y') == now.format('Y') || de.format('Y') == now.format('Y') && de.format('Ymd') > now.format('Ymd')) {
          return _react.default.createElement("p", null, ds.format('F j'), " - ", de.format('F j'));
        }
      }

      return _react.default.createElement("p", null, ds.format('F j, Y'), " - ", de.format('F j, Y'));
    }
  }]);
  return SessionDates;
}(_react.Component), _temp2), (_descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "start", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "end", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
var CourseOverviewTab = (_class5 = (_temp3 =
/*#__PURE__*/
function (_OverviewTab) {
  babelHelpers.inherits(CourseOverviewTab, _OverviewTab);

  function CourseOverviewTab() {
    var _babelHelpers$getProt3;

    var _this3;

    babelHelpers.classCallCheck(this, CourseOverviewTab);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(CourseOverviewTab)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "downloads", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    return _this3;
  }

  babelHelpers.createClass(CourseOverviewTab, [{
    key: "renderFeatures",
    value: function renderFeatures() {
      var r = babelHelpers.get(babelHelpers.getPrototypeOf(CourseOverviewTab.prototype), "renderFeatures", this).call(this);

      if (this.downloads && this.downloads.length) {
        return _react.default.createElement(_react.Fragment, null, _react.default.createElement(Downloads, {
          items: this.downloads
        }), r);
      }

      return r;
    }
  }]);
  return CourseOverviewTab;
}(_Overview.default), _temp3), (_descriptor6 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "downloads", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class5);
exports.CourseOverviewTab = CourseOverviewTab;
var Downloads = (_class7 = (_temp4 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(Downloads, _Component3);

  function Downloads() {
    var _babelHelpers$getProt4;

    var _this4;

    babelHelpers.classCallCheck(this, Downloads);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this4 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt4 = babelHelpers.getPrototypeOf(Downloads)).call.apply(_babelHelpers$getProt4, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this4, "items", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    return _this4;
  }

  babelHelpers.createClass(Downloads, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "resource-group"
      }, _react.default.createElement("h1", null, "Course Resources"), _react.default.createElement("div", {
        className: "resource-group-items"
      }, this.items.map(function (item) {
        return _react.default.createElement(Download, _extends({}, item, {
          key: item.id
        }));
      })));
    }
  }]);
  return Downloads;
}(_react.Component), _temp4), (_descriptor7 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "items", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class7);
var Download = (_class9 = (_temp5 =
/*#__PURE__*/
function (_Component4) {
  babelHelpers.inherits(Download, _Component4);

  function Download() {
    var _babelHelpers$getProt5;

    var _this5;

    babelHelpers.classCallCheck(this, Download);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this5 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt5 = babelHelpers.getPrototypeOf(Download)).call.apply(_babelHelpers$getProt5, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this5, "id", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "access", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "pdfOptions", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "typeName", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "title", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "toolID", _descriptor13, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    return _this5;
  }

  babelHelpers.createClass(Download, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("a", {
        className: "resource-document",
        href: "javascript:void(0)",
        onClick: this.showResource
      }, _react.default.createElement("div", {
        className: "document-icon"
      }, _react.default.createElement("div", {
        className: "document-type"
      }, this.typeName)), _react.default.createElement("div", {
        className: "document-name"
      }, this.title));
    }
  }, {
    key: "showResource",
    value: function showResource(event) {
      event.preventDefault();

      if (this.access != 'enabled') {
        (0, _fetch.default)(location.href + (location.href.indexOf("?") == -1 ? "?" : "&") + "purchaseInfo=1").then(function (result) {
          return result.text();
        }).then(function (result) {
          return Function('', "return ".concat(result)).call(null);
        }).then(function (value) {
          if (value.buttonIsPurchase) {
            if (value.needsLogin) {
              (0, _noty.showNotificationText)("You must be signed in to view this resource.", 'info', 'info');
            } else {
              (0, _noty.showNotificationText)("Please purchase this course to view thi resource.", 'info', 'info');
            }
          } else {
            (0, _noty.showNotificationText)("You do not have permission to view that resource.", 'danger', 'warning');
          }
        });
        return;
      }

      var D = this.pdfOptions;
      var tgt;

      if (!D || !D.pdf) {
        tgt = window.open("about:blank", '_blank');
      }

      (0, _fetch.default)("access/".concat(this.toolID, "/").concat(this.id)).then(function (result) {
        return result.json();
      }).then(function (data) {
        if (data.access == 'enabled') {
          if (tgt) {
            tgt.location.href = data.detail.signedDocumentURL;
          } else {
            var opt = {};
            opt.toolbar = !!D.toolbar;

            if (D.toolbar) {
              opt.controls = Object.keys(D.toolbar).filter(function (v) {
                return D.toolbar[v];
              }).join(',');
            }

            if (data.detail.password) opt.password = darta.detail.password;
            opt.file = data.detail.signedDocumentURL;
            var optString = Object.keys(opt).map(function (key) {
              return [key, opt[key]].map(function (v) {
                return encodeURIComponent;
              }).join('=');
            }).join('&');
            var f = document.createElement('div');
            f.id = 'document-viewer-modal-wrap';
            f.className = 'modal-wrapper fade';
            f.innerHTML = "\n\t\t\t\t\t\t<div class='modal modal-full modal-full-align-top fade' id='document-viewer-modal' role='dialog' tabindex='-1' aria-hidden='true' data-backdrop-parent='#document-viewer-modal-wrap'>\n\t\t\t\t\t\t\t<div class='modal-dialog'>\n\t\t\t\t\t\t\t\t<div class='modal-content'>\n\t\t\t\t\t\t\t\t\t<div class='modal-header'>\n\t\t\t\t\t\t\t\t\t\t".concat(BLX.modalCloseButton(), "\n\t\t\t\t\t\t\t\t\t\t<h4 class='modal-title'>\n\t\t\t\t\t\t\t\t\t\t\t<span class='material-icons' data-icon='insert_drive_file'></span>\n\t\t\t\t\t\t\t\t\t\t\tDocument\n\t\t\t\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class='modal-body'>\n\t\t\t\t\t\t\t\t\t\t<iframe id='document-viewer'></iframe>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t");
            f.querySelector('iframe').src = "/admin/platform/plugins/".concat(_corePlugin.default, "/libraries/pdf.js/web/viewer.html?").concat(optString);
            document.body.appendChild(f);
            $(f.querySelector('.modal')).on('hidden.bs.modal', function () {
              $(f).remove();
            }).modal('show');
          }
        } else {
          if (tgt) tgt.close();
          (0, _noty.showNotificationText)("You do not have permission to view that resource.", 'danger', 'warning');
        }
      });
    }
  }]);
  return Download;
}(_react.Component), _temp5), (_descriptor8 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "access", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "pdfOptions", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "typeName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "toolID", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "showResource", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "showResource"), _class9.prototype)), _class9);
var SingleSessionOverviewTab = (_class11 = (_temp6 =
/*#__PURE__*/
function (_CourseOverviewTab) {
  babelHelpers.inherits(SingleSessionOverviewTab, _CourseOverviewTab);

  function SingleSessionOverviewTab() {
    var _babelHelpers$getProt6;

    var _this6;

    babelHelpers.classCallCheck(this, SingleSessionOverviewTab);

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _this6 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt6 = babelHelpers.getPrototypeOf(SingleSessionOverviewTab)).call.apply(_babelHelpers$getProt6, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this6, "sessionTitle", _descriptor14, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "start", _descriptor15, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "end", _descriptor16, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    return _this6;
  }

  babelHelpers.createClass(SingleSessionOverviewTab, [{
    key: "renderHeader",
    value: function renderHeader() {
      return _react.default.createElement("div", {
        className: "session-container"
      }, _react.default.createElement("p", {
        className: "type"
      }, "Session"), _react.default.createElement("h3", null, this.title), _react.default.createElement(SessionDates, {
        start: this.start,
        end: this.end
      }));
    }
  }]);
  return SingleSessionOverviewTab;
}(CourseOverviewTab), _temp6), (_descriptor14 = babelHelpers.applyDecoratedDescriptor(_class11.prototype, "sessionTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = babelHelpers.applyDecoratedDescriptor(_class11.prototype, "start", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = babelHelpers.applyDecoratedDescriptor(_class11.prototype, "end", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class11);
exports.SingleSessionOverviewTab = SingleSessionOverviewTab;

var ScheduledCourseOverviewTab =
/*#__PURE__*/
function (_CourseOverviewTab2) {
  babelHelpers.inherits(ScheduledCourseOverviewTab, _CourseOverviewTab2);

  function ScheduledCourseOverviewTab() {
    babelHelpers.classCallCheck(this, ScheduledCourseOverviewTab);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(ScheduledCourseOverviewTab).apply(this, arguments));
  }

  return ScheduledCourseOverviewTab;
}(CourseOverviewTab);

exports.ScheduledCourseOverviewTab = ScheduledCourseOverviewTab;
var ScheduledCourseOverviewTabElement = (_class13 = (_temp7 =
/*#__PURE__*/
function (_TabElement) {
  babelHelpers.inherits(ScheduledCourseOverviewTabElement, _TabElement);

  function ScheduledCourseOverviewTabElement() {
    var _babelHelpers$getProt7;

    var _this7;

    babelHelpers.classCallCheck(this, ScheduledCourseOverviewTabElement);

    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    _this7 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt7 = babelHelpers.getPrototypeOf(ScheduledCourseOverviewTabElement)).call.apply(_babelHelpers$getProt7, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this7, "node", _descriptor17, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    return _this7;
  }

  babelHelpers.createClass(ScheduledCourseOverviewTabElement, [{
    key: "getContent",
    value: function getContent() {
      return [_react.default.createElement(ScheduledSessionList, {
        sessions: this.node.props.customElement.sessions,
        key: "sessions"
      }), _react.default.createElement(this.node.type, Object.assign({
        key: "body"
      }, this.node.props, {
        customElement: null
      }))];
    }
  }]);
  return ScheduledCourseOverviewTabElement;
}(_TabPanel.TabElement), _temp7), (_descriptor17 = babelHelpers.applyDecoratedDescriptor(_class13.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class13);
exports.ScheduledCourseOverviewTabElement = ScheduledCourseOverviewTabElement;
var ScheduledSessionList = (_class15 = (_temp8 =
/*#__PURE__*/
function (_Component5) {
  babelHelpers.inherits(ScheduledSessionList, _Component5);

  function ScheduledSessionList() {
    var _babelHelpers$getProt8;

    var _this8;

    babelHelpers.classCallCheck(this, ScheduledSessionList);

    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    _this8 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt8 = babelHelpers.getPrototypeOf(ScheduledSessionList)).call.apply(_babelHelpers$getProt8, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this8, "sessions", _descriptor18, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this8)));
    return _this8;
  }

  babelHelpers.createClass(ScheduledSessionList, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "objectBodyTab"
      }, _react.default.createElement("div", {
        className: "courseSessionList"
      }, this.sessions.map(function (session) {
        return _react.default.createElement("div", {
          key: session.link
        }, _react.default.createElement("div", null, _react.default.createElement(_CourseSessionLineItem.CourseSessionLineItem, session)));
      })));
    }
  }]);
  return ScheduledSessionList;
}(_react.Component), _temp8), (_descriptor18 = babelHelpers.applyDecoratedDescriptor(_class15.prototype, "sessions", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class15);
var OutlineTab = (_class17 = (_temp9 =
/*#__PURE__*/
function (_Component6) {
  babelHelpers.inherits(OutlineTab, _Component6);

  function OutlineTab() {
    var _babelHelpers$getProt9;

    var _this9;

    babelHelpers.classCallCheck(this, OutlineTab);

    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }

    _this9 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt9 = babelHelpers.getPrototypeOf(OutlineTab)).call.apply(_babelHelpers$getProt9, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this9, "ready", _descriptor19, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this9)));
    babelHelpers.initializerDefineProperty(_this9, "background", _descriptor20, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this9)));
    babelHelpers.initializerDefineProperty(_this9, "activities", _descriptor21, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this9)));
    babelHelpers.initializerDefineProperty(_this9, "link", _descriptor22, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this9)));
    babelHelpers.initializerDefineProperty(_this9, "overview", _descriptor23, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this9)));
    babelHelpers.initializerDefineProperty(_this9, "courseTitle", _descriptor24, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this9)));
    return _this9;
  }

  babelHelpers.createClass(OutlineTab, [{
    key: "hide",
    value: function hide() {
      return;
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "objectBodyTab container"
      }, _react.default.createElement("div", {
        id: "course-navigation-placeholder"
      }, _react.default.createElement("div", {
        className: "course-navigation-section"
      }, _react.default.createElement("header", {
        style: _base.default.styleForBackgroundObject(this.background),
        className: this.background ? '' : 'variable-background'
      }, _react.default.createElement("button", {
        className: "close",
        onClick: this.hide,
        type: "button"
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "clear"
      })), _react.default.createElement("a", {
        className: "course-title",
        href: this.link
      }, _react.default.createElement("h3", null, this.courseTitle))), _react.default.createElement("div", {
        className: "course-navigation-body"
      }, _react.default.createElement("div", {
        className: "course-navigation"
      }, _react.default.createElement("div", {
        className: "activity-tree"
      }, _react.default.createElement("div", {
        className: "overview-item"
      }, _react.default.createElement("a", {
        href: this.overview
      }, _react.default.createElement("div", {
        className: "item-icon"
      }, _react.default.createElement("div", null, _react.default.createElement("span", {
        className: "info-icon"
      }))), _react.default.createElement("span", {
        className: "item-title"
      }, "Overview"))), this.ready && this.activities && _react.default.createElement(ActivityTree, {
        activities: this.activities,
        root: true
      })))), _react.default.createElement("div", {
        className: "arrow"
      }))));
    }
  }]);
  return OutlineTab;
}(_react.Component), _temp9), (_descriptor19 = babelHelpers.applyDecoratedDescriptor(_class17.prototype, "ready", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = babelHelpers.applyDecoratedDescriptor(_class17.prototype, "background", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = babelHelpers.applyDecoratedDescriptor(_class17.prototype, "activities", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = babelHelpers.applyDecoratedDescriptor(_class17.prototype, "link", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = babelHelpers.applyDecoratedDescriptor(_class17.prototype, "overview", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = babelHelpers.applyDecoratedDescriptor(_class17.prototype, "courseTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class17.prototype, "hide", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class17.prototype, "hide"), _class17.prototype)), _class17);
exports.OutlineTab = OutlineTab;
var ActivityTree = (_class19 = (_temp10 =
/*#__PURE__*/
function (_Component7) {
  babelHelpers.inherits(ActivityTree, _Component7);

  function ActivityTree() {
    var _babelHelpers$getProt10;

    var _this10;

    babelHelpers.classCallCheck(this, ActivityTree);

    for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      args[_key10] = arguments[_key10];
    }

    _this10 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt10 = babelHelpers.getPrototypeOf(ActivityTree)).call.apply(_babelHelpers$getProt10, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this10, "activities", _descriptor25, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this10)));
    babelHelpers.initializerDefineProperty(_this10, "root", _descriptor26, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this10)));
    return _this10;
  }

  babelHelpers.createClass(ActivityTree, [{
    key: "render",
    value: function render() {
      var className = '';
      if (this.activities.filter(function (v) {
        return !v.section;
      }).length == 0) className = 'activity-tree-sections';
      return _react.default.createElement("ul", {
        className: _classList.default.join('activity-tree-nodes', this.root && 'activity-tree-root', className)
      }, this.activities.map(function (activityNode) {
        return _react.default.createElement(Activity, _extends({}, activityNode, {
          key: activityNode.id
        }));
      }));
    }
  }]);
  return ActivityTree;
}(_react.Component), _temp10), (_descriptor25 = babelHelpers.applyDecoratedDescriptor(_class19.prototype, "activities", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = babelHelpers.applyDecoratedDescriptor(_class19.prototype, "root", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class19);
var Activity = (_class21 = (_temp11 =
/*#__PURE__*/
function (_Component8) {
  babelHelpers.inherits(Activity, _Component8);

  function Activity() {
    var _babelHelpers$getProt11;

    var _this11;

    babelHelpers.classCallCheck(this, Activity);

    for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
      args[_key11] = arguments[_key11];
    }

    _this11 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt11 = babelHelpers.getPrototypeOf(Activity)).call.apply(_babelHelpers$getProt11, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this11, "id", _descriptor27, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this11)));
    babelHelpers.initializerDefineProperty(_this11, "section", _descriptor28, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this11)));
    babelHelpers.initializerDefineProperty(_this11, "title", _descriptor29, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this11)));
    babelHelpers.initializerDefineProperty(_this11, "complete", _descriptor30, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this11)));
    babelHelpers.initializerDefineProperty(_this11, "link", _descriptor31, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this11)));
    babelHelpers.initializerDefineProperty(_this11, "showLink", _descriptor32, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this11)));
    babelHelpers.initializerDefineProperty(_this11, "available", _descriptor33, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this11)));
    babelHelpers.initializerDefineProperty(_this11, "image", _descriptor34, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this11)));
    return _this11;
  }

  babelHelpers.createClass(Activity, [{
    key: "render",
    value: function render() {
      if (this.section) {
        return _react.default.createElement(ActivitySection, this.props);
      }

      var linkProps = {};

      if (this.showLink) {
        linkProps = {
          'data-activity': this.link,
          'data-activity-id': this.id
        };
      }

      return _react.default.createElement("li", {
        className: _classList.default.join('activity-item', this.complete && 'complete', this.available && 'available')
      }, _react.default.createElement("a", _extends({
        className: "activity-link",
        href: this.link
      }, linkProps), _react.default.createElement("div", {
        className: "item-icon"
      }, _react.default.createElement("div", null, _react.default.createElement("img", {
        src: this.image
      }))), _react.default.createElement("div", {
        className: "item-title",
        dangerouslySetInnerHTML: {
          __html: this.title
        }
      }), _react.default.createElement("div", {
        className: "item-status-icon"
      }, this.complete && _react.default.createElement("span", {
        className: "progress-container"
      }, _react.default.createElement("span", {
        className: "progress-circle"
      }, _react.default.createElement("span", {
        className: "pie-8",
        "data-pie": "100"
      }))), this.available && _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "play_arrow"
      }), !this.available && !this.complete && _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "lock_outline"
      }))));
    }
  }]);
  return Activity;
}(_react.Component), _temp11), (_descriptor27 = babelHelpers.applyDecoratedDescriptor(_class21.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = babelHelpers.applyDecoratedDescriptor(_class21.prototype, "section", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = babelHelpers.applyDecoratedDescriptor(_class21.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = babelHelpers.applyDecoratedDescriptor(_class21.prototype, "complete", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = babelHelpers.applyDecoratedDescriptor(_class21.prototype, "link", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = babelHelpers.applyDecoratedDescriptor(_class21.prototype, "showLink", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = babelHelpers.applyDecoratedDescriptor(_class21.prototype, "available", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = babelHelpers.applyDecoratedDescriptor(_class21.prototype, "image", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class21);
var ActivitySection = (_class23 = (_temp12 =
/*#__PURE__*/
function (_Component9) {
  babelHelpers.inherits(ActivitySection, _Component9);

  function ActivitySection() {
    var _babelHelpers$getProt12;

    var _this12;

    babelHelpers.classCallCheck(this, ActivitySection);

    for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      args[_key12] = arguments[_key12];
    }

    _this12 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt12 = babelHelpers.getPrototypeOf(ActivitySection)).call.apply(_babelHelpers$getProt12, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this12, "id", _descriptor35, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this12)));
    babelHelpers.initializerDefineProperty(_this12, "section", _descriptor36, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this12)));
    babelHelpers.initializerDefineProperty(_this12, "title", _descriptor37, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this12)));
    babelHelpers.initializerDefineProperty(_this12, "complete", _descriptor38, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this12)));
    babelHelpers.initializerDefineProperty(_this12, "children", _descriptor39, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this12)));
    return _this12;
  }

  babelHelpers.createClass(ActivitySection, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("li", {
        className: _classList.default.join('activity-section-item', this.complete && 'complete')
      }, _react.default.createElement("div", {
        className: "item-header"
      }, _react.default.createElement("div", {
        className: "item-title"
      }, this.title)), _react.default.createElement("div", {
        className: "item-content"
      }, _react.default.createElement(ActivityTree, {
        activities: this.children
      })));
    }
  }]);
  return ActivitySection;
}(_react.Component), _temp12), (_descriptor35 = babelHelpers.applyDecoratedDescriptor(_class23.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = babelHelpers.applyDecoratedDescriptor(_class23.prototype, "section", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = babelHelpers.applyDecoratedDescriptor(_class23.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = babelHelpers.applyDecoratedDescriptor(_class23.prototype, "complete", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = babelHelpers.applyDecoratedDescriptor(_class23.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class23);